import React from "react";
import { Icon, Message } from "semantic-ui-react";
import { doesNotExist, exists } from "../../utils/utils";

type CustomFailureProps = {
  /** Message header. */
  header: string;
  /** Message content. */
  content: string;
  /** Info content. If empty, will not display info message */
  infoContent?: React.ReactElement;
  isModal?: boolean;
};

class CustomFailure extends React.Component<CustomFailureProps> {
  _renderInfoMessage = () => {
    if (doesNotExist(this.props.infoContent)) return null;
    return (
      <Message info style={{ marginTop: 0 }}>
        {this.props.infoContent}
      </Message>
    );
  };

  _renderStyle = () => {
    const style: React.CSSProperties = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      fontSize: 12,
      position: "absolute",
      zIndex: 999
    };
    if (exists(this.props.isModal) && !this.props.isModal) {
      style.height = "100vh";
    }
    return style;
  };

  render() {
    return (
      <div style={this._renderStyle()}>
        <Message icon compact style={{ width: "auto" }} negative>
          <Icon name="frown outline" />
          <Message.Content style={{ whiteSpace: "pre-wrap" }}>
            <Message.Header style={{ marginBottom: ".5em" }}>{this.props.header}</Message.Header>
            {this.props.content}
          </Message.Content>
        </Message>
        {this._renderInfoMessage()}
      </div>
    );
  }
}

export default CustomFailure;
